import { createApiDescription } from "../../helperFunctions";

export const returnStatusInfo = {
    setDownloadStatus: createApiDescription(
        "This API is used to set the downloaded status for a given tax return.",
        [
            "Status of the return will be changed to downloaded only for applicable statuses.",
            "This API changes the status to downloaded in the grid, update required entries in Download History popup and client tracking as well."
        ]
    )
}